/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import {
    getImagesFromAttribute,
    getImageLabel,
    mapGtmItem
} from "../api/mapping";

const topSearchMapping = {
    /**
     * format product items
     *
     * @param items
     * @returns {*}
     */
    formatProductItems(items) {
        return items.map(item => ({
            name: item.product.name,
            priceRange: item.product.price_range,
            currency: item.product.price_range.maximum_price.regular_price.currency,
            images: getImagesFromAttribute(item),
            imageLabel: getImageLabel(item),
            url: item.product.canonical_url,
            id: item.product.id,
            sku: item.product.sku,
            gtmItem: mapGtmItem(item)
        }));
    },
    /**
     * format product items
     *
     * @param items
     * @returns {*}
     */
    formatContextProductItems(items) {
        return items.map((item, key) => ({
            name: item.product.name,
            sku: item.product.sku,
            url: item.product.canonical_url,
            images: getImagesFromAttribute(item),
            imageLabel: getImageLabel(item),
            price: item.product.price_range.minimum_price.final_price.value,
            rank: key
        }));
    },
    /**
     * format suggestions
     *
     * @param suggestions
     * @returns {*}
     */
    formatContextSuggestions(suggestions) {
        return suggestions.map((item, key) => ({
            suggestion: item,
            rank: key,
        }));
    },
    /**
     * format facets
     *
     * @param facets
     * @returns {*}
     */
    formatContextFacets(facets) {
        return facets.map((facet) => ({
            attribute: facet.attribute,
            title: facet.title,
            type: facet.type || "PINNED",
            buckets: facet.buckets,
        }));
    },
}

export default topSearchMapping;
